import { useState } from "react";

export type ActiveType = "add" | "delete" | "sort";

export const useBottomMenu = () => {
    const [activeType, setActiveType] = useState<
        "add" | "delete" | "sort" | null
    >(null);
    const isPopupOpen = !!activeType;

    const openPopup = (type: ActiveType) => {
        if (activeType === type) {
            closePopup();
            return;
        }

        setActiveType(type);
    };
    const closePopup = () => setActiveType(null);

    return { isPopupOpen, openPopup, closePopup, activeType };
};
